export default __webpack_public_path__ + "static/media/stock-out-suggestion-image.14495116.png";